import { Grid } from '@aloft/toolkit-sui';

import { DefaultEcoLifeInput } from './DefaultEcoLifeInput.tsx';

export function SeparateDefaultEcoLifeTable() {
  return (
    <Grid gridTemplateColumns="repeat(3, 1fr)" columnGap=".75rem">
      <DefaultEcoLifeInput fieldPath="defaultEcoLife" label="Site-Built Dwelling" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeGarage" label="Garage" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeCarport" label="Carport" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifePorch" label="Porch" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifePatio" label="Patio" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeDeck" label="Deck" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeWorkshop" label="Workshop" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeShed" label="Shed" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeBarn" label="Barn" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifePool" label="Pool" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeSpa" label="Spa" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeADU" label="ADU" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeManufactured" label="Manufactured House" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeManualCost" label="Manual Cost" />
      <DefaultEcoLifeInput fieldPath="defaultEcoLifeFireplace" label="Fireplace" />
    </Grid>
  );
}
